import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#ea580c"
    },
    secondary: {
      main: "#1d4ed8"
    },
    background: {
      default: "#f6f7fb",
      paper: "#ffffff"
    },
    text: {
      primary: "#111827",
      secondary: "#6b7280"
    }
  },
  shape: {
    borderRadius: 3
  },
  typography: {
    fontFamily: "\"Poppins\", \"Segoe UI\", sans-serif",
    h3: {
      fontWeight: 800
    },
    h4: {
      fontWeight: 800
    },
    h5: {
      fontWeight: 700
    },
    button: {
      textTransform: "none",
      fontWeight: 700
    }
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 3
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 3,
          boxShadow: "0 16px 36px rgba(15, 23, 42, 0.08)"
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        contained: {
          boxShadow: "none"
        }
      }
    }
  }
});

export default theme;
